import * as React from 'react';
export const redstoneSvg = React.forwardRef(function redstoneSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#00468B',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7.525 7.214V17.74s-.134 1.974 1.739 4.67c1.873 2.696 6.828 4.535 6.828 4.535s4.956-1.839 6.829-4.535c1.873-2.696 1.739-4.67 1.739-4.67V7.214L16.092 6.03 7.525 7.214Z',
      fill: '#E42B26',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'm16.092 5.5 9.093 1.257v10.986l.002.086c0 .071-.003.172-.012.299a6.594 6.594 0 0 1-.172 1.058c-.215.89-.676 2.119-1.65 3.522-1.012 1.456-2.814 2.638-4.299 3.441a25.554 25.554 0 0 1-2.717 1.264l-.045.017-.012.005-.003.001h-.001l-.184-.492c-.182.493-.183.492-.183.492l-.004-.001-.012-.005-.045-.017a21.98 21.98 0 0 1-.768-.317 25.573 25.573 0 0 1-1.95-.947c-1.485-.803-3.286-1.985-4.298-3.44-.975-1.404-1.435-2.632-1.65-3.523a6.595 6.595 0 0 1-.172-1.058 4.095 4.095 0 0 1-.01-.385V6.756L16.092 5.5Zm0 21.444-.183.492.183.068.184-.068-.184-.492Zm0-.563a24.498 24.498 0 0 1-2.462-1.155c-1.46-.79-3.073-1.876-3.935-3.117-.898-1.292-1.307-2.4-1.493-3.17a5.552 5.552 0 0 1-.145-.888 3.064 3.064 0 0 1-.008-.271v-.008l.001-.015V7.672l8.042-1.112 8.043 1.112v10.101l.001.007v.049c0 .047 0 .122-.008.222a5.54 5.54 0 0 1-.146.888c-.185.77-.594 1.878-1.492 3.17-.862 1.241-2.475 2.327-3.935 3.117a24.517 24.517 0 0 1-2.463 1.155Z',
      fill: '#F99B1C',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M8.104 7.752c1.546-.202 6.728-.907 7.862-1 3.511 0 4.007 4.242 3.746 6.661-.126 1.201-1.343 3.234-3.645 3.326 0 0 2.243 4.015 6.081 5.67-.932 1.075-2.419 2.2-4.544 3.242l-4.35-4.057.21 3.427c-5.082-2.47-5.267-6.837-5.267-6.837L8.104 7.752Z',
      fill: '#FDB913',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M15.958 6.547h.008c.923 0 1.658.28 2.233.747.571.464.972 1.103 1.246 1.807.546 1.404.604 3.105.471 4.334-.068.648-.425 1.496-1.059 2.195-.578.636-1.394 1.157-2.444 1.287a16.545 16.545 0 0 0 1.41 1.903c1.03 1.198 2.527 2.59 4.406 3.4l.258.111-.184.212c-.955 1.102-2.467 2.242-4.609 3.292l-.126.062-4.079-3.803.2 3.265-.315-.154c-2.587-1.256-3.935-3.002-4.634-4.439a8.088 8.088 0 0 1-.635-1.818 6.037 6.037 0 0 1-.112-.74v-.014s-.001-.002.204-.01l-.205.01v-.008L7.898 7.572l.18-.023 1.38-.183c2.16-.288 5.59-.745 6.492-.818h.008Zm-7.556 11.63v.007a1.81 1.81 0 0 0 .016.168c.015.118.04.292.088.51.093.434.27 1.042.603 1.725.635 1.305 1.839 2.893 4.128 4.09l-.22-3.583 4.623 4.31c1.905-.947 3.27-1.957 4.168-2.923-1.836-.856-3.291-2.226-4.295-3.394a16.96 16.96 0 0 1-1.206-1.58 13.052 13.052 0 0 1-.391-.62l-.02-.035-.006-.01-.001-.002.178-.1-.179.1-.163-.292.334-.014c1.087-.043 1.917-.544 2.495-1.18.581-.64.897-1.41.955-1.962.128-1.19.068-2.82-.447-4.142-.256-.659-.621-1.231-1.122-1.638-.496-.403-1.136-.653-1.965-.655-.902.075-4.294.526-6.448.813l-1.216.162.09 10.246Z',
      fill: '#F99B1C',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm13.43 8.525.345 2.771 1.797-1.881-1.243 2.285 2.26-.378-2.05 1.024 2.805 1.286-3.015-.63.79 1.57-1.345-1.167-.344 2.268-.344-2.268-2.293 2.562L12.53 13l-2.259.379 2.05-1.034-1.722-.915 1.931.269-1.058-2.041 1.613 1.637.344-2.771Z',
      fill: '#fff',
    }),
  );
});
redstoneSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var redstone = {
  category: 'brand',
  colorable: false,
  name: 'redstone',
  svg: redstoneSvg,
};
